import { useEffect, useMemo, useState } from "react";
import GalleryFolder from "../../components/Global/GalleryFolder";
import Header from "../../components/Global/Header";
import LoadingComponent from "../../components/Global/Loading";
import { StyledMain } from "./styles";

import { initializeApp } from "firebase/app";
import { getStorage, listAll, ref } from "firebase/storage";

const firebaseConfig = {
	apiKey: "AIzaSyBokxAhCwSbXRnehbdC6z7JlYNwBPXVVuU",
	authDomain: "site-valentin.firebaseapp.com",
	projectId: "site-valentin",
	storageBucket: "site-valentin.appspot.com",
	messagingSenderId: "302720444451",
	appId: "1:302720444451:web:eb81039d3e1f54295a2996",
};

const firebaseApp = initializeApp(firebaseConfig);

export default function Gallery() {
	const [isLoading, setIsLoading] = useState(true);

	const [database, setDatabase] = useState<
		| {
				treatedWord: string;
				data: string;
		  }[]
		| never[]
	>([]);

	const storage = getStorage(firebaseApp);
	const storageRef = ref(storage, `gs://site-valentin.appspot.com/images/`);

	useEffect(() => {
		document.title = "Site do Valentin | Galeria";
		const getItem = async () => {
			const srcArray: any = [];
			const list = await listAll(storageRef);

			const listArray = await list.prefixes;

			await listArray;

			listArray.forEach((listItem) => {
				const treatedWord = listItem.fullPath
					.split("images/")[1]
					.replaceAll("-", " ")
					.split(" ")
					.map((word) => word[0].toUpperCase() + word.substring(1))
					.join(" ");
				const data = listItem.fullPath.split("images/")[1];

				srcArray.push({ treatedWord, data });
			});

			return srcArray;
		};

		getItem().then((res) => {
			setDatabase(res);
			setIsLoading(false);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const monthOrders: any = useMemo(
		() => ({
			"1": "primeiro",
			"2": "segundo",
			"3": "terceiro",
			"4": "quarto",
			"5": "quinto",
			"6": "sexto",
			"7": "setimo",
			"8": "oitavo",
			"9": "nono",
			"10": "decimo",
			"11": "mes 11",
			"12": "mes 12",
		}),
		[]
	);

	const orderedData = useMemo(() => {
		if (!!database) {
			const sortedData: any = [];
			const restData: any = [];
			for (const month in monthOrders) {
				const rightItem = database.find((item, index) => {
					return item.data.toLowerCase().includes(monthOrders[month]);
				});
				if (rightItem) sortedData.push(rightItem);
			}

			database.forEach(
				(item) =>
					!sortedData.some(
						(anotherItem: any) => anotherItem.data === item.data
					) && restData.push(item)
			);
			return [...sortedData, ...restData];
		}
		return [];
	}, [database, monthOrders]);

	return (
		<>
			<StyledMain>
				<section className="gallery_container">
					<h1 className="gallery_title">Galeria de Fotos</h1>
					<ul>
						{!!orderedData &&
							orderedData.map((folder, i) => {
								return <GalleryFolder key={i} payload={folder} />;
							})}
					</ul>
				</section>

				{isLoading && <LoadingComponent />}
			</StyledMain>
		</>
	);
}
